module.exports = __webpack_public_path__ + "845f123d84a93913267ffbee4388ea8e.png";